module.exports = __webpack_public_path__ + "img/medecin_ordi.99a9c8f7.jpg";